export { default } from "./column.component"
